import { defineMessage } from 'react-intl';

export const statusMessages = {
  all: defineMessage({
    id: `logger.status.filter.all`,
    defaultMessage: 'Todas',
  }),
  online: defineMessage({
    id: `logger.status.filter.online`,
    defaultMessage: 'Online',
  }),
  offline: defineMessage({
    id: `logger.status.filter.offline`,
    defaultMessage: 'Offline',
  }),
};

export enum StatusFilterType {
  ALL = 'all',
  ONLINE = 'online',
  OFFLINE = 'offline',
}

/** Filter values for station type: radio, non-YouTube TV, or YouTube Native. */
export enum StationTypeFilterType {
  ALL = 'all',
  RADIO = 'radio',
  TV = 'tv',
  YOUTUBE = 'youtube',
}
